export default {
  props: {
    pending: { type: Boolean, default: false }
  },
}
